import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        /* 登录 */
        {
            path: '/login',
            component: resolve => require.ensure([], () => resolve(require('views/Login/index')), 'Login'),
            name: 'Login',
            redirect: '/mobile',
            meta: {
                same: true
            },
            children: [
                {
                    path: '/mobile',
                    name: 'mobile',
                    component: resolve => require.ensure([], () => resolve(require('views/Login/components/mobile')), 'mobile'),
                    meta: {
                        same: true
                    },
                },
                {
                    path: '/qqlogin',
                    name: 'QQ',
                    component: resolve => require.ensure([], () => resolve(require('views/Login/components/qq')), 'QQ'),
                    meta: {
                        same: true
                    },

                },
                {
                    path: '/login_wechat',
                    name: 'weChart',
                    component: resolve => require.ensure([], () => resolve(require('views/Login/components/wechart')), 'weChart'),
                    meta: {
                        same: true
                    },
                },
                {
                    path: '/bindwxcallback',
                    name: 'BindWechat',
                    component: resolve => require.ensure([], () => resolve(require('views/Login/components/BindWechat')), 'BindWechat'),
                    meta: {
                        same: true
                    },
                },
                {
                    path: '/loginapi/login/qqLogin',
                    name: 'BindQQ',
                    component: resolve => require.ensure([], () => resolve(require('@/views/Login/components/BindQQ')), 'BindQQ'),
                    meta: {
                        same: true
                    },
                },

            ]
        },
        /* 用户协议 */
        {
            path: '/userAgree',
            name: 'userAgree',
            // component: resolve => require.ensure([], () => resolve(require('views/Settings/userAgree')), 'userAgree'),
            component: resolve => require.ensure([], () => resolve(require('views/agreement')), 'userAgree'),
            
        },
        /* 主体 */
        {
            path: '/',
            name: 'home',
            // redirect: '/home',
            component: resolve => require.ensure([], () => resolve(require('views/home')), 'home'),
            
        },
        {
            path: '/client',
            name: 'client',
            // redirect: '/home',
            component: resolve => require.ensure([], () => resolve(require('views/client')), 'client'),
        },
        {
            path: '/aboutus',
            name: 'aboutus',
            // redirect: '/home',
            component: resolve => require.ensure([], () => resolve(require('views/about')), 'about'),
        },
        {
            path: '/Paas',
            name: 'Paas',
            // redirect: '/home',
            component: resolve => require.ensure([], () => resolve(require('views/pass')), 'Paas'),
        },
        {
            path: '/Iaas',
            name: 'Iaas',
            // redirect: '/home',
            component: resolve => require.ensure([], () => resolve(require('views/Iaas')), 'Iaas'),
        },
        {
            path: '/jubao',
            name: 'jubao',
            // redirect: '/home',
            component: resolve => require.ensure([], () => resolve(require('views/jubao')), 'jubao'),
        },
        {
            path: '/recharge',
            name: 'recharge',
            component: resolve => require.ensure([], () => resolve(require('views/Recharge')), 'recharge'),
        },
        {
            path: '/user',
            name: 'user',
            component: resolve => require.ensure([], () => resolve(require('views/user')), 'user'),
        },
        {
            path: '/privacy',
            name: 'privacy',
            component: resolve => require.ensure([], () => resolve(require('views/privacy')), 'privacy'),
            meta: {
                same: true
            },
        },
        {
            path: '/custody',
            name: 'custody',
            component: resolve => require.ensure([], () => resolve(require('views/custody')), 'custody'),
            meta: {
                same: true
            },
        },
        {
            path: '/dispute',
            name: 'dispute',
            component: resolve => require.ensure([], () => resolve(require('views/dispute')), 'dispute'),
            meta: {
                same: true
            },
        },
        /* 邀请落地页 */
        {
            path: '/inviteRegister',
            name: 'inviteRegister',
            component: resolve => require.ensure([], () => resolve(require('views/inviteRegister')), 'inviteRegister'),
            meta: {
                show: true
            },
        },
    ]
})

router.beforeEach((to, from, next) => {
    const isLogined = !!window.localStorage.getItem('token')
    if (to.matched.some(item => item.meta.needsLogin) && !isLogined) {
        router.push('/mobile')
    } else {
        next()
    }
})

export default router